import { useFormattedDate } from '@common/hooks/formatters/useFormattedDate';
import { Text } from '@radix-ui/themes';

interface FormattedDateProps {
    date: number | Date;
    options?: Intl.DateTimeFormatOptions;
}

export const FormattedDate = ({ date, options }: FormattedDateProps) => {
    const { formatDate } = useFormattedDate(options);
    return <Text>{formatDate(date)}</Text>;
};
